import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeIndex from '../views/HomeIndex.vue'
import BusinessContainer from '../views/business/BusinessContainer.vue'
import InfluencerContainer from '../views/influencer/InfluencerContainer.vue'

// Fix Vue router - Navigation aborted from “/a“ to “/b“ via a navigation guard
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }

  return originalPush.call(this, location)
    .catch(err => {
      if (err.name !== 'NavigationDuplicated') throw err
    })
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    component: HomeIndex,
  },
  {
    path: '/signup/:user',
    components: {
      default: () => import(/* webpackChunkName: "SignUp" */ '../views/SignUp.vue'),
    },
  },
  {
    path: '/business',
    redirect: 'business/home',
    component: BusinessContainer,
    children: [
      {
        path: 'home',
        name: 'BusinessHome',
        components: {
          default: () => import(/* webpackChunkName: "home" */ '../views/business/BusinessHome.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
        },
      },
      {
        path: 'campaigns/all',
        name: 'BusinessCampaignsAll',
        components: {
          default: () => import(/* webpackChunkName: "campaignsAll" */ '../views/business/BusinessCampaignsAll.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
        },
      },
      {
        path: 'campaigns/detail/:campaignId',
        name: 'BusinessCampaignsDetail',
        components: {
          default: () => import(/* webpackChunkName: "campaignsAll" */ '../views/business/BusinessCampaignsDetail.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
        },
      },
      // {
      //   path: 'campaigns/progress',
      //   name: 'BusinessCampaignsProgress',
      //   components: {
      //     default: () => import(/* webpackChunkName: "campaignsProgress" */ '../views/business/BusinessCampaignsProgress.vue'),
      //     nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
      //   },
      // },
      {
        path: 'campaigns/applicants',
        name: 'BusinessCampaignsApplicants',
        components: {
          default: () => import(/* webpackChunkName: "campaignsApplicants" */ '../views/business/BusinessCampaignsApplicants.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
        },
      },
      {
        path: 'campaigns/applicants/profile/:applicantId',
        name: 'BusinessCampaignsApplicantsProfile',
        components: {
          default: () => import(/* webpackChunkName: "campaignsApplicants" */ '../views/business/BusinessCampaignsApplicantsProfile.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
        },
      },
      {
        path: 'campaigns/create',
        name: 'BusinessCampaignsCreate',
        components: {
          default: () => import(/* webpackChunkName: "campaignsCreate" */ '../views/business/BusinessCampaignsCreate.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
        },
      },
      {
        path: 'campaigns/performance',
        name: 'BusinessCampaignsPerformance',
        components: {
          default: () => import(/* webpackChunkName: "campaignsPerformance" */ '../views/business/BusinessCampaignsPerformance.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
        },
      },
      {
        path: 'campaigns/performance/:campaignId',
        name: 'BusinessCampaignsPerformanceDetail',
        components: {
          default: () => import(/* webpackChunkName: "campaignsPerformance" */ '../views/business/BusinessCampaignsPerformanceDetail.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
        },
      },
      // {
      //   path: 'influencers',
      //   redirect: 'influencers/search',
      //   name: 'BusinessInfluencers',
      //   components: {
      //     default: () => import(/* webpackChunkName: "influencers" */ '../views/business/BusinessInfluencers.vue'),
      //     nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
      //   },
      // },
      {
        path: 'influencers/search',
        name: 'BusinessInfluencersSearch',
        components: {
          default: () => import(/* webpackChunkName: "influencersSearch" */ '../views/business/BusinessInfluencersSearch.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
        },
      },
      {
        path: 'influencers/saved',
        name: 'BusinessInfluencersSaved',
        components: {
          default: () => import(/* webpackChunkName: "influencersSaved" */ '../views/business/BusinessInfluencersSaved.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
        },
      },
      {
        path: 'wallet',
        name: 'BusinessWallet',
        components: {
          default: () => import(/* webpackChunkName: "wallet" */ '../views/business/BusinessWallet.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
        },
      },
      {
        path: 'profile',
        name: 'BusinessProfile',
        components: {
          default: () => import(/* webpackChunkName: "profile" */ '../views/business/BusinessProfile.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
        },
      },
      {
        path: 'messages',
        name: 'BusinessMessages',
        components: {
          default: () => import(/* webpackChunkName: "campaigns" */ '../views/business/BusinessMessages.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/business/BusinessNav.vue'),
        },
      },
    ]
  },
  {
    path: '/influencer',
    redirect: 'influencer/home',
    component: InfluencerContainer,
    children: [
      {
        path: 'home',
        name: 'InfluencerHome',
        components: {
          default: () => import(/* webpackChunkName: "home" */ '../views/influencer/InfluencerHome.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/influencer/InfluencerNav.vue'),
        },
      },
      // {
      //   path: 'campaigns',
      //   redirect: 'campaigns/mine',
      //   name: 'InfluencerCampaigns',
      //   components: {
      //     default: () => import(/* webpackChunkName: "campaigns" */ '../views/influencer/InfluencerCampaigns.vue'),
      //     nav: () => import(/* webpackChunkName: "nav" */ '../views/influencer/InfluencerNav.vue'),
      //   },
      // },
      {
        path: 'campaigns/mine',
        name: 'InfluencerCampaignsMine',
        components: {
          default: () => import(/* webpackChunkName: "campaignsMine" */ '../views/influencer/InfluencerCampaignsMine.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/influencer/InfluencerNav.vue'),
        },
      },
      {
        path: 'campaigns/applied',
        name: 'InfluencerCampaignsApplied',
        components: {
          default: () => import(/* webpackChunkName: "campaignsApplied" */ '../views/influencer/InfluencerCampaignsApplied.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/influencer/InfluencerNav.vue'),
        },
      },
      {
        path: 'campaigns/search',
        name: 'InfluencerCampaignsSearch',
        components: {
          default: () => import(/* webpackChunkName: "campaignsSearch" */ '../views/influencer/InfluencerCampaignsSearch.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/influencer/InfluencerNav.vue'),
        },
      },
      {
        path: 'campaigns/detail/:campaignId',
        name: 'InfluencerCampaignsDetail',
        components: {
          default: () => import(/* webpackChunkName: "campaignsAll" */ '../views/influencer/InfluencerCampaignsDetail.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/influencer/InfluencerNav.vue'),
        },
      },
      {
        path: 'wallet',
        name: 'InfluencerWallet',
        components: {
          default: () => import(/* webpackChunkName: "wallet" */ '../views/influencer/InfluencerWallet.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/influencer/InfluencerNav.vue'),
        },
      },
      {
        path: 'profile',
        name: 'InfluencerProfile',
        components: {
          default: () => import(/* webpackChunkName: "profile" */ '../views/influencer/InfluencerProfile.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/influencer/InfluencerNav.vue'),
        },
      },
      {
        path: 'messages',
        name: 'InfluencerMessages',
        components: {
          default: () => import(/* webpackChunkName: "messages" */ '../views/influencer/InfluencerMessages.vue'),
          nav: () => import(/* webpackChunkName: "nav" */ '../views/influencer/InfluencerNav.vue'),
        },
      },
    ],
  },
  // {
  //   path: '/:path(.*)',
  //   components: {
  //     default: () => import(/* webpackChunkName: "NotFound" */ '../views/NotFound.vue'),
  //   },
  //   name: '404',
  // },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
